import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import I18n from '@module/i18n';
import Analytics from '@module/analytics';

import Actions from '@app/store/action';

import VideoIllustration from '@component/illustration/video-illustration';

export const TermsConditions = ({ acceptTermsAndConditions }) => {
  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: 'show_terms_and_cookie',
      label: 'i_agree',
    });
  }, []);

  const grantConsent = () => {
    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: 'click_give_consent',
      label: 'i_agree',
    });
    acceptTermsAndConditions();
  };

  return (
    <div className="transfer__window terms-conditions">
      <div className="transfer__contents">
        <VideoIllustration
          type="transfer-tandc"
          src="transfer_window/terms_and_conditions"
          className="terms__image"
        />
        <p
          dangerouslySetInnerHTML={{
            __html: I18n.t('transfer.terms_conditions.text', {
              options: ' data-route-type="plus"',
            }),
          }}
        />
      </div>
      <div className="transfer__footer">
        <button className="transfer__button" onClick={grantConsent}>
          {I18n.t('transfer.terms_conditions.button')}
        </button>
      </div>
    </div>
  );
};

TermsConditions.propTypes = {
  acceptTermsAndConditions: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
};

const mapStateToProps = ({ session }) => ({ session });
export const mapDispatchToProps = (dispatch) => ({
  acceptTermsAndConditions: () => {
    dispatch(Actions.Session.acceptTermsConditions());
    dispatch(Actions.Notification.clearTransfer());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsConditions);
